import { createFileRoute } from '@tanstack/react-router'
import { ScNextBestActionsPage } from '@/features/support-coordination/next-best-actions'

export const Route = createFileRoute(
  '/_authenticated/_organization/support-coordination/next-best-actions',
)({
  component: ScNextBestActionsPage,
})
